"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseKetoProductCard = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactOurTakeHighlight = _interopRequireDefault(require("@nerdwallet/react-our-take-highlight"));
var _impression = require("@nerdwallet/analytics/react/impression");
var _CheckboxOption = require("@nerdwallet/currency/components/CheckboxOption");
var _bainComponents = require("@nerdwallet/bain-components");
var _ketoProductCardModule = _interopRequireDefault(require("./keto-product-card.module.css"));
var BaseKetoProductCard = function BaseKetoProductCard(_ref) {
  var _ref2;
  var accordionNode = _ref.accordionNode,
    _ref$addToFavoritesNo = _ref.addToFavoritesNode,
    addToFavoritesNode = _ref$addToFavoritesNo === void 0 ? null : _ref$addToFavoritesNo,
    className = _ref.className,
    driversNode = _ref.driversNode,
    forceMobile = _ref.forceMobile,
    headerNode = _ref.headerNode,
    imageAndRatingNode = _ref.imageAndRatingNode,
    alternateCta = _ref.alternateCta,
    isInCompare = _ref.isInCompare,
    isPreheaderBadge = _ref.isPreheaderBadge,
    ourTakeHighlight = _ref.ourTakeHighlight,
    sectionName = _ref.sectionName,
    sideBySideCompareOptions = _ref.sideBySideCompareOptions,
    checkboxLabel = _ref.checkboxLabel,
    handleCompare = _ref.handleCompare,
    isSelectedToCompare = _ref.isSelectedToCompare,
    _ref$isNwPlusVariant = _ref.isNwPlusVariant,
    isNwPlusVariant = _ref$isNwPlusVariant === void 0 ? false : _ref$isNwPlusVariant,
    isLimitedTimeOffer = _ref.isLimitedTimeOffer,
    isLTODynamicPlacement = _ref.isLTODynamicPlacement;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([className, _ketoProductCardModule.default.ketoProductCardContainer, (_ref2 = {}, (0, _defineProperty2.default)(_ref2, _ketoProductCardModule.default.ketoProductCardTopMargin, !isPreheaderBadge), (0, _defineProperty2.default)(_ref2, _ketoProductCardModule.default.ketoProductCardContainerCheckBoxSelected, isInCompare), (0, _defineProperty2.default)(_ref2, _ketoProductCardModule.default.forceMobile, forceMobile), (0, _defineProperty2.default)(_ref2, _ketoProductCardModule.default.ketoProductCardSBSCTopMargin, sideBySideCompareOptions), (0, _defineProperty2.default)(_ref2, _ketoProductCardModule.default.nwPlusVariant, isNwPlusVariant), (0, _defineProperty2.default)(_ref2, _ketoProductCardModule.default.ketoProductCardLTOTopMargin, isLimitedTimeOffer || isLTODynamicPlacement), (0, _defineProperty2.default)(_ref2, _ketoProductCardModule.default.ketoProductCardBlueBorder, isLTODynamicPlacement), _ref2)])
  }, sideBySideCompareOptions && !addToFavoritesNode && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([className, _ketoProductCardModule.default.ketoSbscHeader, !isPreheaderBadge && _ketoProductCardModule.default.ketoSbscHeaderBottomMargin, (0, _defineProperty2.default)({}, _ketoProductCardModule.default.sbscVariantPosition, sideBySideCompareOptions.variantPosition)])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)([_ketoProductCardModule.default.compareBtnDesktop, isPreheaderBadge && _ketoProductCardModule.default.compareTopMargin])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.compareCheckbox
  }, /*#__PURE__*/_react.default.createElement(_impression.ImpressionContext.Consumer, null, function (value) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "keto-compare-checkbox"
    }, /*#__PURE__*/_react.default.createElement(_CheckboxOption.CheckboxOption, {
      className: "input",
      label: checkboxLabel || (isSelectedToCompare ? 'Added to Compare' : 'Add to Compare'),
      defaultChecked: isSelectedToCompare,
      onChange: function onChange() {
        return handleCompare(value === null || value === void 0 ? void 0 : value.impressionId);
      },
      inline: true
    }));
  })))), isLimitedTimeOffer && !isLTODynamicPlacement && /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.ketoLtoHeaderBottomMargin
  }, /*#__PURE__*/_react.default.createElement(_bainComponents.LTOBanner, {
    version: "ribbon"
  })), isLTODynamicPlacement && /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.ketoLtoAdBugHeaderBottomMargin
  }, /*#__PURE__*/_react.default.createElement(_bainComponents.LTOBanner, {
    version: "adbug"
  })), addToFavoritesNode && /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.favoritesHeader
  }, addToFavoritesNode), /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.ketoProductCardHeader
  }, headerNode), /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.ketoBody
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.ketoImageAndRatingContainer
  }, imageAndRatingNode), ourTakeHighlight && /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.ketoOurTakeWrapper
  }, /*#__PURE__*/_react.default.createElement(_reactOurTakeHighlight.default, {
    bannerType: ourTakeHighlight.type,
    content: ourTakeHighlight.content,
    analytics: {
      entityName: 'cc_product_our_take_flag',
      sectionName: sectionName
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.ketoProductCardDriversContent
  }, driversNode), alternateCta && /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.alternateCta
  }, alternateCta)), /*#__PURE__*/_react.default.createElement("div", {
    className: _ketoProductCardModule.default.ketoProductCardAccordion
  }, accordionNode), isLimitedTimeOffer && !isLTODynamicPlacement && /*#__PURE__*/_react.default.createElement(_bainComponents.LTODetails, null));
};
exports.BaseKetoProductCard = BaseKetoProductCard;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');
  BaseKetoProductCard.propTypes = {
    accordionNode: PropTypes.node,
    alternateCta: PropTypes.node,
    className: PropTypes.string,
    driversNode: PropTypes.node,
    forceMobile: PropTypes.bool,
    headerNode: PropTypes.node,
    imageAndRatingNode: PropTypes.node,
    isInCompare: PropTypes.bool,
    isNwPlusVariant: PropTypes.bool,
    isPreheaderBadge: PropTypes.bool,
    sectionName: PropTypes.string
  };
}
var _default = BaseKetoProductCard;
exports.default = _default;